import React from 'react'
import { InputAdornment, InputAdornmentProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  () => ({
    hiddenAdornment: {
      visibility: 'hidden',
    },
  }),
  { name: 'PuiInputAdornment' },
)

export interface PuiInputAdornmentProps extends InputAdornmentProps {
  readonly hidden?: boolean
}

const PuiInputAdornment = ({
  hidden,
  position = 'end',
  ...rest
}: PuiInputAdornmentProps) => {
  const classes = useStyles()

  return (
    <InputAdornment
      className={classNames({
        [classes.hiddenAdornment]: hidden,
      })}
      position={position}
      {...rest}
    />
  )
}

export default PuiInputAdornment
